module.exports = __webpack_public_path__ + "static/vmware_30.3d80a4a2.jpg";